import { useAuth } from '../auth/AuthContext';

/**
 * Whether a bill list covers every till.
 *
 * Staff see their own bills by default — the lists are where they find the
 * bill in front of them — and widen to the whole shop with the box. The
 * server always gives an admin every till, so for an admin this is simply
 * true and there is no box to show.
 */
export function useCoversWholeShop(ticked: boolean): boolean {
  const { user } = useAuth();
  return ticked || user?.role !== 'COUNTER_STAFF';
}

export default function WholeShopToggle({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  const { user } = useAuth();
  if (user?.role !== 'COUNTER_STAFF') return null;

  return (
    <label className="field field-check">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>Show whole shop</span>
    </label>
  );
}

/** Who rang a bill up, under its time, once the list is not all one person's. */
export function BillBy({ name }: { name?: string | null }) {
  if (!name) return null;
  return <span className="bill-by">{name}</span>;
}
